import {AuthRequest, AuthResult, otsBaseApi, Person} from "@ots-frontend/ots-data";
import {createSlice} from "@reduxjs/toolkit";
import {AppState} from "../store";
import {setAuthCredentials, setAuthToken, setAuthUser} from "./actions";

export const authApi = otsBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    legacyLogin: builder.mutation<AuthResult, AuthRequest>({
      query: (creds) => ({
        url: "/auth/user",
        method: "POST",
        body: creds
      })
    }),
    protected: builder.mutation<{ message: string }, void>({
      query: () => "protected"
    })
  })
});

export const {useLegacyLoginMutation, useProtectedMutation} = authApi;

type AuthState = {
  authToken?: string;
  user?: Person
}

const INITIAL_STATE: Readonly<AuthState> = {
  authToken: undefined,
  user: undefined
};

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setAuthToken,
      (state, {payload}) => {
        state.authToken = payload;
      }
    );
    builder.addCase(
      setAuthUser,
      (state, {payload}) => {
        state.user = payload;
      }
    );
    builder.addCase(
      setAuthCredentials,
      (state, {payload}) => {
        state.authToken = payload.authToken;
        state.user = payload.user
      }
    );
  }
});

export const authReducer = authSlice.reducer;

export const getAuthToken = (state: AppState) => state.auth.authToken;
export const getAuthUser = (state: AppState) => state.auth.user;
